// extracted by mini-css-extract-plugin
export var contactInfo = "footer-module--contactInfo--d1d21";
export var donateButton = "footer-module--donateButton--b6a8b";
export var footerCTA = "footer-module--footerCTA--58e33";
export var footerCTABackground = "footer-module--footerCTABackground--6674b";
export var footerCTAContent = "footer-module--footerCTAContent--0bd7d";
export var footerCTAbannerOverlay = "footer-module--footerCTAbannerOverlay--04912";
export var paidFor = "footer-module--paidFor--eedfd";
export var siteFooter = "footer-module--siteFooter--dac1c";
export var siteLogo = "footer-module--siteLogo--06ba4";